module.exports = __webpack_public_path__ + "img/logo-radar.21045b45.svg";